<template>
  <div class="log">
    <div class="log_box fl1" @click.stop.prevent="goIndex()">{{ times }}s 跳过</div>
  </div>
</template>

<script>
  import { getT } from '@/api/sys'
  import { getSystz } from "@/api/sys"
  import wx from 'weixin-js-sdk'
  import { getIndex } from "../../api/index"
  import { getToken, getInlet } from "../../api/index"
  export default {
    components: {},
    data() {
      return {
        key: '',
        int: null,
        times: 3,
        main: '',
        endDate: '',
        listData: [{ title: '兴科物联 智慧充电' }],
        staDate: null,
        tem: '',
        isMobile: false,
      };
    },
    methods: {
      // 入口配置
      inlet() {
        // 获取URL的查询参数,将其转换为一个对象
        const searchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(searchParams.entries());
        if (params.mch_id && params.member_id) {
          localStorage.setItem("MchId", params.mch_id);
          localStorage.setItem("MemberId", params.member_id);
          localStorage.setItem("VenderId", params.vender_id);
          this.$router.push({
            path: "/indexs",
          });
          return;
        } else {
          this.key = params.key;
          this.getTokens();
        }
      },
      getTokens() {
        getToken({ vender_key: this.key }).then((data1) => {
          if (data1) {
            if (data1.data.code == 1) {
              this.main = data1.data.data.main_vender_id;
              localStorage.setItem("main", data1.data.data.main_vender_id);
              localStorage.setItem("token", data1.data.data.token);
              localStorage.setItem("type", data1.data.data.vender_type);
              if (localStorage.getItem("token")) {
                this.getDates();
                this.get();
                // 获取入口 
                getInlet({ token: localStorage.getItem("token") }).then(data => {
                  if (data.data.code == 1) {
                    this.worktable = data.data.data.check_worktable;
                    if (this.worktable == 1) {
                      this.$router.push({
                        path: "/index",
                        query: {
                          int: this.isMobile,
                          listData: this.listData,
                          tem: this.tem,
                        }
                      });
                    } else if (this.worktable == 0) {
                      this.$router.push({ path: "/menu" });
                    }
                  }
                })
              }
            }
          } else {
            getT().then(data => {
              if (data.data.code == 1) {
                window.location.href = data.data.data;
                localStorage.clear();
              }
            });
          }
        });
      },
      goIndex() {
        clearInterval(this.int1);
        this.isMobile = this.iss();
        this.inlet();
        localStorage.setItem("key", this.key);
      },
      async get() {
        let data = await getSystz({ token: localStorage.getItem('token') });
        if (data.data.code == 1) {
          this.listData = data.data.data;
        }
      },
      async getDates() {
        let data = await getIndex({ token: localStorage.getItem("token"), start_time: this.staDate, end_time: this.endDate });
        if (data.data.code == 1) {
          this.tem = data.data.data;
        }
      },
      iss() {
        const reg = /(Android|iPhone|iPad|Windows Phone|HarmonyOS|OpenHarmony)/i;
        const userAgent = navigator.userAgent;
        return reg.test(userAgent);
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        const searchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(searchParams.entries());
        if (params.mch_id && params.member_id) {
          localStorage.setItem("MchId", params.mch_id);
          localStorage.setItem("MemberId", params.member_id);
          localStorage.setItem("VenderId", params.vender_id);
          vm.$router.push({
            path: "/indexs",
          });
          return;
        }
      });
    },
    created() {
      this.staDate = this.$moment().startOf('month').format('YYYY-MM-DD');
      this.endDate = this.$moment().subtract(0, 'months').format('YYYY-MM-DD');
      localStorage.clear();
    },
    mounted() {
      this.isMobile = this.iss();
      this.int1 = setInterval(() => {
        this.times--;
        if (this.times <= 0) {
          clearInterval(this.int1);
          this.inlet();
        }
      }, 1000)
      if (this.$route.query.id == -8) {
        getT().then((data) => {
          if (data.data.code == 1) {
            window.location.href = data.data.data;
            localStorage.clear();
          }
        })
      }
    }
  }
</script>
<style lang="less">
  .log {
    width: 100%;
    height: 100vh;
    background: url(../../assets/index/lo.jpg) 0 0 no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .log_box {
      padding: .7rem 1rem;
      top: 1.6rem;
      right: 1.4rem;
      position: absolute;
      color: #fff;
      justify-content: center;
      border-radius: 1rem;
      background-color: rgba(0, 0, 0, 0.5);
    }
  }
</style>